import {useSelector} from 'react-redux';

import {actions as bulkEditActions} from '../duck';
import {useActions} from '../../../utils/globalStore';

import type {FilterType} from '../duck';
import type {RootState} from '../..';

const filterSelector = (state: RootState) => state.bulkEdit.filter;
const productFilterActions = bulkEditActions.setProductFilter;

export function useProductFilter() {
  const filter = useSelector(filterSelector);
  const setProductFilter = useActions(productFilterActions);

  const setFilter = (type: FilterType) => {
    setProductFilter({type, value: []});
  };

  return {
    filter,
    setFilter,
  };
}

export function useToggleFilter() {
  const filter = useSelector(filterSelector);
  const setFilter = useActions(productFilterActions);

  const toggleFilterValue = (value: string) => {
    const newFilter = {...filter};
    const index = newFilter.value.indexOf(value);
    if (index > -1) {
      newFilter.value.splice(index, 1);
    } else {
      newFilter.value.push(value);
    }
    setFilter(newFilter);
  };

  const toggleUniqueFilterValue = (value: string) => {
    const newFilter = {...filter};
    newFilter.value = [value];
    setFilter(newFilter);
  };

  const resetFilters = () => {
    const newFilter = {...filter};
    newFilter.value = [];
    setFilter(newFilter);
  };

  return {
    filter,
    toggleFilterValue,
    toggleUniqueFilterValue,
    resetFilters,
  };
}
